import { css } from '@emotion/css';
import { cssVarV2 } from '@toeverything/theme/v2';

export const mobileTableView = css({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
});

export const mobileTableViewWrapper = css({
  position: 'relative',
  paddingBottom: '4px',
  zIndex: 1,
  overflowX: 'scroll',
  overflowY: 'hidden',
});

export const mobileTableViewContainer = css({
  position: 'relative',
  width: 'fit-content',
  minWidth: '100%',
});

export const mobileCellDivider = css({
  width: '1px',
  height: '100%',
  backgroundColor: cssVarV2.layer.insideBorder.border,
});
